export default "__VITE_ASSET__CvaGwhhd__"